import { MemberStatus } from './Groups'
import { UserRoles } from './Users'

export enum EventName {
  COURSE_ACCESS_REFRESH = 'course-access-refresh',
  NO_COMMUNITIES_FOUND = 'no-communities-found',
  COMMUNITIES_GROUP_ACCESS = 'communities-group-access-event',
}
export interface ITrackEvent {
  eventName: EventName
  contactId?: string
  locationId?: string
  groupId?: string
  eventData: Record<string, any>
}

export interface ITrackCommunitiesAccessEvent extends ITrackEvent {
  eventName: EventName.COMMUNITIES_GROUP_ACCESS
  groupId: string
  status: MemberStatus
  role: UserRoles
}
